import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useProgram(programId) {
  const [program, setProgram] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.programs.show(programId))
      .then((response) => {
        setProgram(response.data.data);
      });
  }, []);

  return program;
}
